export default __webpack_public_path__ + "static/media/carousel-img-11.777921df.webp";